import type { ReportSource } from 'garaje/models/approval-status';
import { SCREENER_RESULT_SOURCE_DISPLAY_NAMES } from 'garaje/utils/enums';

export function getScreenerDisplayName(screener: ReportSource): string {
  return SCREENER_RESULT_SOURCE_DISPLAY_NAMES[screener];
}
